module.exports = __webpack_public_path__ + "media/images/front/brands/signature/card-9f71ac1cca41b561777768d5a211a2be.webp";